import type { Restaurant, RestaurantEvent } from "@/types/restaurant";
import type { TickerEvent } from "@/types/events";

/**
 * Join events to their owning restaurant and format the ticker line as
 * "Restaurant Name: Event text". Events whose restaurant is missing from
 * the lookup are dropped — that's the right call for a public feed: don't
 * show orphaned messaging for venues that have been deactivated.
 */
export function buildTickerFeed(
  events: RestaurantEvent[],
  restaurants: Restaurant[] | Record<string, Restaurant>,
): TickerEvent[] {
  const byId: Record<string, Restaurant> = Array.isArray(restaurants)
    ? Object.fromEntries(restaurants.map((r) => [r.id, r]))
    : restaurants;

  const out: TickerEvent[] = [];
  for (const e of events) {
    const r = byId[e.restaurant_id];
    if (!r) continue;
    out.push({
      id: e.id,
      text: `${r.name}: ${e.text}`,
      kind: e.kind,
      href: e.href,
      startsAt: e.starts_at,
      expiresAt: e.expires_at,
    });
  }
  return out;
}
